export default {
  alliance: {
    language_1: 'Vui lòng tạo hoặc gia nhập liên minh trước',
    language_2: 'Không đủ lượt quay, hãy hoàn thành nhiệm vụ để nhận thêm',
    language_3: 'Vui lòng đăng nhập trước',
    language_4: 'Sắp ra mắt',
    language_5: 'Sao chép thành công!',
    language_6: 'Sao chép thất bại, vui lòng thử sao chép thủ công',
    language_7: 'Sao chép thành công! Hãy nhanh chóng mời bạn bè tham gia liên minh nhé',
    footer: {
      language_1: 'Rules',
      language_2: 'Privacy Policy',
      language_3: 'VIP Terms'
    },
    home: {
      language_1_1: 'Xin chào, [',
      language_1_2: ']',
      language_2: 'Thành Viên: ',
      language_3: 'Điểm Liên Minh: ',
      language_4: 'Số Liên Minh Hiện Có: ',
      language_5: 'Nhập ID hoặc Tên Liên Minh Dự Bị',
      // language_6: "ID ",
      language_7: 'Bang Chủ',
      language_8: 'Thành Viên',
      language_9: 'Tuyên Ngôn',
      language_10: '[Đăng Nhập]',
      create: {
        language_1: 'Nhập (tối đa 30 ký tự)',
        language_2: 'Nhập (tối đa 30 ký tự)',
        language_3: 'Nhập (tối đa 100 ký tự)',
        language_4: 'Nhập liên kết nhóm'
      }
    },
    luckyDraw: {
      language_1: 'Lượt quay còn lại: '
    },
    quests: {
      language_1: ' điểm',
      language_2: ' lượt quay',
      language_3: 'Chia sẻ trang lần đầu mỗi ngày',
      language_4: 'Mời bạn bè tham gia',
      language_5: 'Đăng ký trước tại cửa hàng',
      language_6: 'Theo dõi Facebook chính thức',
      language_7: 'Tham gia Discord chính thức'
    },
    confirmDialog: {
      language_1:
        'Mỗi tài khoản chỉ có 1 lần tạo hoặc gia nhập liên minh. Sau khi xác nhận sẽ không thể hủy, bạn có chắc chắn không?'
    },
    successDialog: {
      language_1: 'Chúc mừng bạn đã gia nhập liên minh',
      language_2: 'Tạo liên minh thành công',
      language_3: 'Hoàn thành nhiệm vụ liên minh, nhận điểm và lượt quay để giành nhiều phần thưởng hấp dẫn!'
    },
    myRewardsDialog: {
      language_1: ' Thành Viên',
      language_2: 'Lệnh Tụ Nghĩa x'
    },
    preSelectedServerDialog: {
      language_1: 'Máy chủ',
      language_2:
        '※Vui lòng đăng nhập game bằng chính tài khoản RASTAR GAMES đã tham gia sự kiện Lập Trước Liên Minh. Hãy tạo nhân vật bằng tài khoản này trong vòng 6 giờ sau khi Open Beta bắt đầu để vào trực tiếp máy chủ đã chọn mà không bị giới hạn bởi trạng thái máy chủ. Mỗi máy chủ chỉ có tối đa 3 suất đặt trước dành cho Liên Minh, áp dụng theo nguyên tắc ai đăng ký trước được trước. Khi đủ số lượng sẽ không thể tiếp tục đăng ký.'
    },
    receivedDialog: {
      language_1:
        '*Phần thưởng sẽ được phát hành dưới dạng mã đổi quà tại trang sự kiện này sau khi game mở cửa thử nghiệm công khai. Người chơi cần đăng nhập bằng tài khoản RASTAR GAMES trên trang sự kiện để nhận thưởng'
    },
    speedRankingDialog: {
      language_1: 'Áp dụng cho ',
      language_2: 'Hạng',
      language_3: 'Máy Chủ',
      language_4: 'Tên Liên Minh',
      language_5: 'Thời Gian',
      language_6: 'Cập nhật lúc: ',
      language_7: ' phút',
      language_8: ' giây'
    }
  }
}
